module.exports = __webpack_public_path__ + "img/text-file (SVG).25821a76.svg";